<template>
  <div class="otp-enter-phone-wrapper">
    <div class="icon-wrapper">
      <phone-icon />
    </div>

    <div v-if="!firstStep" class="text-header-1 mb-8px">{{ $t('customerInfoStep.otp.addPhone') }}</div>
    <div v-else class="text-header-1 mb-8px">{{ $t('customerInfoStep.otp.addPhoneToBegin') }}</div>
    <div v-if="!firstStep" class="text-body-4 mb-32px otp-enter-phone-disclaimer">
      {{ $t('customerInfoStep.otp.phoneDisclaimer') }}
    </div>
    <div v-else class="text-body-4 mb-32px otp-enter-phone-disclaimer">
      {{ $t('customerInfoStep.otp.phoneDisclaimer') }}
    </div>

    <el-input
      :placeholder="$t('customerInfoStep.otp.phonePlaceholder')"
      type="tel"
      v-model="phone"
      autocomplete="tel"
      inputmode="tel"
      oninput="this.value = this.value.replace(/[^\d+]+/g, '').replace(/(\..*)\./g, '$1')"
    />

    <transition name="fade-faster">
      <div class="mt-12px" v-if="error">
        <el-alert class="text-left" effect="dark" :title="error" type="error" />
      </div>
    </transition>

    <el-checkbox v-model="transactionalCommunications" class="terms-checkbox mt-16px">
      <div class="text-body-5 text-left">By checking, you are allowing to receive transactional/informational SMS communications regarding account
        notifications, customer care, etc., from {{ accountName }}. Messages frequency may vary. Data rates may apply,
        reply STOP to opt-out.
      </div>
    </el-checkbox>

    <el-checkbox class="terms-checkbox mt-8px" v-model="marketingCommunications">
      <div class="text-body-5 text-left">By checking, you are allowing to receive promotional/marketing SMS communications from {{ accountName }}.
        Frequency may vary. Data rates may apply, reply HELP for help or STOP to opt-out.
      </div>
    </el-checkbox>

    <el-checkbox class="terms-checkbox mt-8px" v-model="termsAccepted">
      <div class="text-body-5 text-left">By checking you accept
        <router-link :to="'/terms?shop=' + this.accountSlug" target="_blank">
          {{ $t('general.termsAndConditions') }}
        </router-link>
        &
        <router-link :to="'/privacy?shop=' + this.accountSlug" target="_blank">
          {{ $t('general.privacyPolicy') }} </router-link
        >. No mobile information will be shared with third parties.
      </div>
    </el-checkbox>

    <!-- <el-checkbox class="terms-checkbox mt-16px" v-model="termsAccepted">
      <div v-if="!firstStep" class="text-body-5 text-left">
        {{ $t('customerInfoStep.otp.optInDisclaimer.phone.generic', { accountName }) }}
        <router-link :to="'/terms?shop=' + this.accountSlug" target="_blank">
          {{ $t('general.termsAndConditions') }}
        </router-link>
        |
        <router-link :to="'/privacy?shop=' + this.accountSlug" target="_blank">
          {{ $t('general.privacyPolicy') }}
        </router-link>
      </div>
      <div v-else class="text-body-5 text-left">
        {{ $t('customerInfoStep.otp.optInDisclaimer.phone.lastStep', { accountName }) }}
        <router-link :to="'/terms?shop=' + this.accountSlug" target="_blank">
          {{ $t('general.termsAndConditions') }}
        </router-link>
        |
        <router-link :to="'/privacy?shop=' + this.accountSlug" target="_blank">
          {{ $t('general.privacyPolicy') }}
        </router-link>
      </div>
    </el-checkbox> -->

    <transition name="fade-faster">
      <sticked-to-bottom-button
        v-if="phone && phone.length >= 4 && ((termsAccepted && accountRequiredOptIn) || !accountRequiredOptIn)"
        :loading="loading"
        @btn-click="sendOTP"
      />
    </transition>
  </div>
</template>

<script>
import PhoneIcon from './PhoneIcon';
import StickedToBottomButton from '@/components/global/StickedToBottomButton';

import OTPService from '@/services/OTPService';

export default {
  name: 'EnterCustomerPhone',
  components: {
    PhoneIcon,
    StickedToBottomButton,
  },
  props: {
    accountSlug: {
      type: String,
      required: true,
    },
    accountName: {
      type: String,
      required: true,
    },
    accountOtpSetting: {
      type: String,
      required: true,
    },
    accountRequiredOptIn: {
      type: Boolean,
      required: true,
    },
    firstStep: {
      type: Boolean,
      required: false,
    },
    actionButtonDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      phone: '',
      email: '',
      loading: false,
      error: '',
      transactionalCommunications: false,
      marketingCommunications: false,
      termsAccepted: false,
    };
  },
  methods: {
    async sendOTP() {
      if (this.actionButtonDisabled) return;

      if (this.error) this.error = '';

      try {
        this.loading = true;
        let data, response;
        if (this.accountOtpSetting === 'sms') {
          response = await OTPService.post.sendOTP(this.accountSlug, this.phone, this.transactionalCommunications, this.marketingCommunications);
        } else {
          response = await OTPService.post.sendEmailOTP(this.accountSlug, this.phone, this.transactionalCommunications, this.marketingCommunications);
        }
        data = response.data || {};
        this.loading = false;
        this.$posthog.capture('addPhoneNumber_*_otpSent');
        this.$emit('otp-sent', {
          phone: this.phone,
          email: data.email || '',
          otpSent: data.otp_sent,
          termsAccepted: this.termsAccepted,
        });

        this.$emit('set-customer-blocked-from-booking', {
          blockedFromBooking: data.customer_blocked_from_booking || false,
        });

        // Enabled abandonment timer
        this.$emit('start-abandonment-timer', { phone: this.phone, email: this.email });
      } catch (error) {
        this.loading = false;
        console.log('error', error);
        this.error = error.response.data.message || '';
        this.$posthog.capture('addPhoneNumber_*_otpSentFailed', {
          errorMessage: this.error,
        });
      }
    },
  },
};
</script>

<style></style>
